// 商務背包 
export const productItemsBag = [
  {
    picUrl: require('@/pages/home/img/020_1.jpg'),
    srcList: [
      require('@/pages/home/img/020_1.jpg'),
      require('@/pages/home/img/020_2.jpg'),
      require('@/pages/home/img/020_3.jpg'),
      require('@/pages/home/img/020_4.jpg'),
      require('@/pages/home/img/020_5.jpg'),
      require('@/pages/home/img/020_6.jpg'),
      require('@/pages/home/img/020_7.jpg'),
      require('@/pages/home/img/020_8.jpg'),
      require('@/pages/home/img/020_9.jpg')
    ],
    name: '商務背包',
    number: 'NBYS-000020',
    myColor1: '#f1ca17',
    myColor2: '#5dbe8a',
    text1: 'Only 1 color',
    text2: '2-Piece Set'
  },
  {
    picUrl: require('@/pages/home/img/040_1.jpg'),
    srcList: [
      require('@/pages/home/img/040_1.jpg'),
      require('@/pages/home/img/040_2.jpg'),
      require('@/pages/home/img/040_3.jpg'),
      require('@/pages/home/img/040_4.jpg'),
      require('@/pages/home/img/040_5.jpg'),
      require('@/pages/home/img/040_6.jpg'),
      require('@/pages/home/img/040_7.jpg'),
      require('@/pages/home/img/040_8.jpg'),
      require('@/pages/home/img/040_9.jpg')
    ],
    name: '商務背包',
    number: 'NBYS-000040',
    myColor1: '#f1ca17',
    myColor2: '#5dbe8a',
    text1: 'Only 1 color',
    text2: '2-Piece Set'
  },
  {
    picUrl: require('@/pages/home/img/042_1.jpg'),
    srcList: [
      require('@/pages/home/img/042_1.jpg'),
      require('@/pages/home/img/042_2.jpg'),
      require('@/pages/home/img/042_3.jpg'),
      require('@/pages/home/img/042_4.jpg'),
      require('@/pages/home/img/042_5.jpg'),
      require('@/pages/home/img/042_6.jpg'),
      require('@/pages/home/img/042_7.jpg'),
      require('@/pages/home/img/042_8.jpg'),
      require('@/pages/home/img/042_9.jpg')
    ],
    name: '商務背包',
    number: 'NBYS-000042',
    myColor1: '#f1ca17',
    myColor2: '#5dbe8a',
    text1: 'Only 1 color',
    text2: '2-Piece Set'
  },
  {
    picUrl: require('@/pages/home/img/0541_1.jpg'),
    srcList: [
      require('@/pages/home/img/0541_1.jpg'),
      require('@/pages/home/img/0541_2.jpg'),
      require('@/pages/home/img/0541_3.jpg'),
      require('@/pages/home/img/0541_4.jpg'),
      require('@/pages/home/img/0541_5.jpg'),
      require('@/pages/home/img/0541_6.jpg'),
      require('@/pages/home/img/0541_7.jpg'),
      require('@/pages/home/img/0541_8.jpg'),
      require('@/pages/home/img/0541_9.jpg')
    ],
    name: '商務背包',
    number: 'NBYS-000541',
    myColor1: '#f1ca17',
    myColor2: '#5dbe8a',
    text1: 'Only 1 color',
    text2: '2-Piece Set'
  },
  {
    picUrl: require('@/pages/home/img/0542_1.jpg'),
    srcList: [
      require('@/pages/home/img/0542_1.jpg'),
      require('@/pages/home/img/0542_2.jpg'),
      require('@/pages/home/img/0542_3.jpg'),
      require('@/pages/home/img/0542_4.jpg'),
      require('@/pages/home/img/0542_5.jpg'),
      require('@/pages/home/img/0542_6.jpg'),
      require('@/pages/home/img/0542_7.jpg'),
      require('@/pages/home/img/0542_8.jpg'),
      require('@/pages/home/img/0542_9.jpg')
    ],
    name: '商務背包',
    number: 'NBYS-000542',
    myColor1: '#f1ca17',
    myColor2: '#5dbe8a',
    text1: 'Only 1 color',
    text2: '2-Piece Set'
  },
  {
    picUrl: require('@/pages/home/img/0543_1.jpg'),
    srcList: [
      require('@/pages/home/img/0543_1.jpg'),
      require('@/pages/home/img/0543_1.jpg'),
      require('@/pages/home/img/0543_1.jpg'),
      require('@/pages/home/img/0543_1.jpg'),
      require('@/pages/home/img/0543_1.jpg'),
      require('@/pages/home/img/0543_1.jpg'),
      require('@/pages/home/img/0543_1.jpg'),
      require('@/pages/home/img/0543_1.jpg'),
      require('@/pages/home/img/0543_1.jpg')
    ],
    name: '商務背包',
    number: 'NBYS-0000543',
    myColor1: '#f1ca17',
    myColor2: '#5dbe8a',
    text1: 'Only 1 color',
    text2: '2-Piece Set'
  },
  {
    picUrl: require('@/pages/home/img/0544_1.jpg'),
    srcList: [
      require('@/pages/home/img/0544_1.jpg'),
      require('@/pages/home/img/0544_2.jpg'),
      require('@/pages/home/img/0544_3.jpg'),
      require('@/pages/home/img/0544_4.jpg'),
      require('@/pages/home/img/0544_5.jpg'),
      require('@/pages/home/img/0544_6.jpg'),
      require('@/pages/home/img/0544_7.jpg'),
      require('@/pages/home/img/0544_8.jpg'),
      require('@/pages/home/img/0544_9.jpg')
    ],
    name: '商務背包',
    number: 'NBYS-000544',
    myColor1: '#f1ca17',
    myColor2: '#5dbe8a',
    text1: 'Only 1 color',
    text2: '2-Piece Set'
  },
  {
    picUrl: require('@/pages/home/img/0545_1.jpg'),
    srcList: [
      require('@/pages/home/img/0545_1.jpg'),
      require('@/pages/home/img/0545_2.jpg'),
      require('@/pages/home/img/0545_3.jpg'),
      require('@/pages/home/img/0545_4.jpg'),
      require('@/pages/home/img/0545_5.jpg'),
      require('@/pages/home/img/0545_6.jpg'),
      require('@/pages/home/img/0545_7.jpg'),
      require('@/pages/home/img/0545_8.jpg'),
      require('@/pages/home/img/0545_9.jpg')
    ],
    name: '商務背包',
    number: 'NBYS-000545',
    myColor1: '#f1ca17',
    myColor2: '#5dbe8a',
    text1: 'Only 1 color',
    text2: '2-Piece Set'
  },
  {
    picUrl: require('@/pages/home/img/0546_1.jpg'),
    srcList: [
      require('@/pages/home/img/0546_1.jpg'),
      require('@/pages/home/img/0546_2.jpg'),
      require('@/pages/home/img/0546_3.jpg'),
      require('@/pages/home/img/0546_4.jpg'),
      require('@/pages/home/img/0546_5.jpg'),
      require('@/pages/home/img/0546_6.jpg'),
      require('@/pages/home/img/0546_7.jpg'),
      require('@/pages/home/img/0546_8.jpg'),
      require('@/pages/home/img/0546_9.jpg')
    ],
    name: '商務背包',
    number: 'NBYS-000546',
    myColor1: '#f1ca17',
    myColor2: '#5dbe8a',
    text1: 'Only 1 color',
    text2: '2-Piece Set'
  },
  {
    picUrl: require('@/pages/home/img/0547_1.jpg'),
    srcList: [
      require('@/pages/home/img/0547_1.jpg'),
      require('@/pages/home/img/0547_2.jpg'),
      require('@/pages/home/img/0547_3.jpg'),
      require('@/pages/home/img/0547_4.jpg'),
      require('@/pages/home/img/0547_5.jpg'),
      require('@/pages/home/img/0547_6.jpg'),
      require('@/pages/home/img/0547_7.jpg'),
      require('@/pages/home/img/0547_8.jpg'),
      require('@/pages/home/img/0547_9.jpg')
    ],
    name: '商務背包',
    number: 'NBYS-000547',
    myColor1: '#f1ca17',
    myColor2: '#5dbe8a',
    text1: 'Only 1 color',
    text2: '2-Piece Set'
  },
  
  //  以上 10 個

  {
    picUrl: require('@/pages/home/img/1805_1.jpg'),
    srcList: [
      require('@/pages/home/img/1805_1.jpg'),
      require('@/pages/home/img/1805_2.jpg'),
      require('@/pages/home/img/1805_3.jpg'),
      require('@/pages/home/img/1805_4.jpg'),
      require('@/pages/home/img/1805_5.jpg'),
      require('@/pages/home/img/1805_6.jpg'),
      require('@/pages/home/img/1805_7.jpg'),
      require('@/pages/home/img/1805_8.jpg'),
      require('@/pages/home/img/1805_9.jpg')
    ],
    name: '商務背包',
    number: 'NBYS-001805',
    myColor1: '#f1ca17',
    myColor2: '#5dbe8a',
    text1: 'Only 1 color',
    text2: '2-Piece Set'
  },
  {
    picUrl: require('@/pages/home/img/1807-54_1.jpg'),
    srcList: [
      require('@/pages/home/img/1807-54_1.jpg'),
      require('@/pages/home/img/1807-54_1.jpg'),
      require('@/pages/home/img/1807-54_1.jpg'),
      require('@/pages/home/img/1807-54_1.jpg'),
      require('@/pages/home/img/1807-54_1.jpg'),
      require('@/pages/home/img/1807-54_1.jpg'),
      require('@/pages/home/img/1807-54_1.jpg'),
      require('@/pages/home/img/1807-54_1.jpg'),
      require('@/pages/home/img/1807-54_1.jpg')
    ],
    name: '商務背包',
    number: 'NBYS-001807-54',
    myColor1: '#f1ca17',
    myColor2: '#5dbe8a',
    text1: 'Only 1 color',
    text2: '2-Piece Set'
  },
  {
    picUrl: require('@/pages/home/img/042_1.jpg'),
    srcList: [
      require('@/pages/home/img/042_1.jpg'),
      require('@/pages/home/img/042_2.jpg'),
      require('@/pages/home/img/042_3.jpg'),
      require('@/pages/home/img/042_4.jpg'),
      require('@/pages/home/img/042_5.jpg'),
      require('@/pages/home/img/042_6.jpg'),
      require('@/pages/home/img/042_7.jpg'),
      require('@/pages/home/img/042_8.jpg'),
      require('@/pages/home/img/042_9.jpg')
    ],
    name: '商務背包',
    number: 'NBYS-000020',
    myColor1: '#f1ca17',
    myColor2: '#5dbe8a',
    text1: 'Only 1 color',
    text2: '2-Piece Set'
  },
  {
    picUrl: require('@/pages/home/img/1808_1.jpg'),
    srcList: [
      require('@/pages/home/img/1808_1.jpg'),
      require('@/pages/home/img/1808_2.jpg'),
      require('@/pages/home/img/1808_3.jpg'),
      require('@/pages/home/img/1808_4.jpg'),
      require('@/pages/home/img/1808_5.jpg'),
      require('@/pages/home/img/1808_6.jpg'),
      require('@/pages/home/img/1808_7.jpg'),
      require('@/pages/home/img/1808_8.jpg'),
      require('@/pages/home/img/1808_9.jpg')
    ],
    name: '商務背包',
    number: 'NBYS-0001808',
    myColor1: '#f1ca17',
    myColor2: '#5dbe8a',
    text1: 'Only 1 color',
    text2: '2-Piece Set'
  },
  {
    picUrl: require('@/pages/home/img/1809_1.jpg'),
    srcList: [
      require('@/pages/home/img/1809_1.jpg'),
      require('@/pages/home/img/1809_1.jpg'),
      require('@/pages/home/img/1809_1.jpg'),
      require('@/pages/home/img/1809_1.jpg'),
      require('@/pages/home/img/1809_1.jpg'),
      require('@/pages/home/img/1809_1.jpg'),
      require('@/pages/home/img/1809_1.jpg'),
      require('@/pages/home/img/1809_1.jpg'),
      require('@/pages/home/img/1809_1.jpg')
    ],
    name: '商務背包',
    number: 'NBYS-001809',
    myColor1: '#f1ca17',
    myColor2: '#5dbe8a',
    text1: 'Only 1 color',
    text2: '2-Piece Set'
  },
  {
    picUrl: require('@/pages/home/img/1810_1.jpg'),
    srcList: [
      require('@/pages/home/img/1810_1.jpg'),
      require('@/pages/home/img/1810_2.jpg'),
      require('@/pages/home/img/1810_3.jpg'),
      require('@/pages/home/img/1810_4.jpg'),
      require('@/pages/home/img/1810_5.jpg'),
      require('@/pages/home/img/1810_6.jpg'),
      require('@/pages/home/img/1810_7.jpg'),
      require('@/pages/home/img/1810_8.jpg'),
      require('@/pages/home/img/1810_9.jpg')
    ],
    name: '商務背包',
    number: 'NBYS-0001810',
    myColor1: '#f1ca17',
    myColor2: '#5dbe8a',
    text1: 'Only 1 color',
    text2: '2-Piece Set'
  },
  {
    picUrl: require('@/pages/home/img/1901_1.jpg'),
    srcList: [
      require('@/pages/home/img/1901_1.jpg'),
      require('@/pages/home/img/1901_2.jpg'),
      require('@/pages/home/img/1901_3.jpg'),
      require('@/pages/home/img/1901_4.jpg'),
      require('@/pages/home/img/1901_5.jpg'),
      require('@/pages/home/img/1901_6.jpg'),
      require('@/pages/home/img/1901_7.jpg'),
      require('@/pages/home/img/1901_8.jpg'),
      require('@/pages/home/img/1901_9.jpg')
    ],
    name: '商務背包',
    number: 'NBYS-001901',
    myColor1: '#f1ca17',
    myColor2: '#5dbe8a',
    text1: 'Only 1 color',
    text2: '2-Piece Set'
  },
  {
    picUrl: require('@/pages/home/img/021_1.jpg'),
    srcList: [
      require('@/pages/home/img/021_1.jpg'),
      require('@/pages/home/img/021_2.jpg'),
      require('@/pages/home/img/021_3.jpg'),
      require('@/pages/home/img/021_4.jpg'),
      require('@/pages/home/img/021_5.jpg'),
      require('@/pages/home/img/021_6.jpg'),
      require('@/pages/home/img/021_7.jpg'),
      require('@/pages/home/img/021_8.jpg'),
      require('@/pages/home/img/021_9.jpg')
    ],
    name: '商務背包',
    number: 'NBYS-000021',
    myColor1: '#f1ca17',
    myColor2: '#5dbe8a',
    text1: 'Only 1 color',
    text2: '2-Piece Set'
  },
  {
    picUrl: require('@/pages/home/img/02344_1.jpg'),
    srcList: [
      require('@/pages/home/img/02344_1.jpg'),
      require('@/pages/home/img/02344_2.jpg'),
      require('@/pages/home/img/02344_3.jpg'),
      require('@/pages/home/img/02344_4.jpg'),
      require('@/pages/home/img/02344_5.jpg'),
      require('@/pages/home/img/02344_6.jpg'),
      require('@/pages/home/img/02344_7.jpg'),
      require('@/pages/home/img/02344_8.jpg'),
      require('@/pages/home/img/02344_9.jpg')
    ],
    name: '商務背包',
    number: 'NBYS-002344',
    myColor1: '#f1ca17',
    myColor2: '#5dbe8a',
    text1: 'Only 1 color',
    text2: '2-Piece Set'
  },
  {
    picUrl: require('@/pages/home/img/02450_1.jpg'),
    srcList: [
      require('@/pages/home/img/02450_1.jpg'),
      require('@/pages/home/img/02450_2.jpg'),
      require('@/pages/home/img/02450_3.jpg'),
      require('@/pages/home/img/02450_4.jpg'),
      require('@/pages/home/img/02450_5.jpg'),
      require('@/pages/home/img/02450_6.jpg'),
      require('@/pages/home/img/02450_7.jpg'),
      require('@/pages/home/img/02450_8.jpg'),
      require('@/pages/home/img/02450_9.jpg')
    ],
    name: '商務背包',
    number: 'NBYS-0002450',
    myColor1: '#f1ca17',
    myColor2: '#5dbe8a',
    text1: 'Only 1 color',
    text2: '2-Piece Set'
  },

  {
    picUrl: require('@/pages/home/img/02560_1.jpg'),
    srcList: [
      require('@/pages/home/img/02560_1.jpg'),
      require('@/pages/home/img/02560_2.jpg'),
      require('@/pages/home/img/02560_3.jpg'),
      require('@/pages/home/img/02560_4.jpg'),
      require('@/pages/home/img/02560_5.jpg'),
      require('@/pages/home/img/02560_6.jpg'),
      require('@/pages/home/img/02560_7.jpg'),
      require('@/pages/home/img/02560_8.jpg'),
      require('@/pages/home/img/02560_9.jpg')
    ],
    name: '商務背包',
    number: 'NBYS-000547',
    myColor1: '#f1ca17',
    myColor2: '#5dbe8a',
    text1: 'Only 1 color',
    text2: '2-Piece Set'
  },
  {
    picUrl: require('@/pages/home/img/180153_1.jpg'),
    srcList: [
      require('@/pages/home/img/180153_1.jpg'),
      require('@/pages/home/img/180153_2.jpg'),
      require('@/pages/home/img/180153_3.jpg'),
      require('@/pages/home/img/180153_4.jpg'),
      require('@/pages/home/img/180153_5.jpg'),
      require('@/pages/home/img/180153_6.jpg'),
      require('@/pages/home/img/180153_7.jpg'),
      require('@/pages/home/img/180153_8.jpg'),
      require('@/pages/home/img/180153_9.jpg')
    ],
    name: '商務背包',
    number: 'NBYS-000547',
    myColor1: '#f1ca17',
    myColor2: '#5dbe8a',
    text1: 'Only 1 color',
    text2: '2-Piece Set'
  }


];



// WEBPACK FOOTER //
// ./src/pages/Home/config.js